import { useEffect, useState } from "react";
import { Clock, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { todayISO } from "@/lib/format";

const EMPTY = { technician_id: "", date: todayISO(), start: "18:00", end: "20:00", note: "" };

export function OvertimeRequestButton({ onDone }) {
  const [open, setOpen] = useState(false);
  const [staff, setStaff] = useState([]);
  const [f, setF] = useState(EMPTY);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    if (!open) { return; }
    api.get("/admin/technicians").then((r) => setStaff(r.data.filter((t) => t.active !== false && t.employment !== "autonomo")));
  }, [open]);
  const upd = (k) => (e) => setF((p) => ({ ...p, [k]: e.target.value }));
  const send = async () => {
    if (!f.technician_id) return toast.error("Scegli il dipendente");
    setBusy(true);
    try {
      await api.post("/admin/overtime", f);
      toast.success("Richiesta inviata: il dipendente riceve la notifica");
      setOpen(false); setF(EMPTY); onDone?.();
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button className="rounded-full" data-testid="overtime-request-button"><Clock className="h-4 w-4" /> Richiedi straordinario</Button>
      </DialogTrigger>
      <DialogContent data-testid="overtime-dialog">
        <DialogHeader><DialogTitle>Richiesta di straordinario</DialogTitle></DialogHeader>
        <div className="space-y-3">
          <div className="space-y-2"><Label>Dipendente</Label>
            <Select value={f.technician_id} onValueChange={(v) => setF((p) => ({ ...p, technician_id: v }))}>
              <SelectTrigger data-testid="overtime-tech-select"><SelectValue placeholder="Scegli…" /></SelectTrigger>
              <SelectContent>{staff.map((t) => <SelectItem key={t.id} value={t.id}>{t.name}</SelectItem>)}</SelectContent>
            </Select>
          </div>
          <div className="grid grid-cols-3 gap-2">
            <div className="col-span-3 space-y-2 sm:col-span-1"><Label>Giorno</Label><Input type="date" min={todayISO()} value={f.date} onChange={upd("date")} data-testid="overtime-date" /></div>
            <div className="space-y-2"><Label>Dalle</Label><Input type="time" value={f.start} onChange={upd("start")} data-testid="overtime-start" /></div>
            <div className="space-y-2"><Label>Alle</Label><Input type="time" value={f.end} onChange={upd("end")} data-testid="overtime-end" /></div>
          </div>
          <div className="space-y-2"><Label>Nota (facoltativa)</Label><Textarea rows={2} value={f.note} onChange={upd("note")} placeholder="Es. consegna urgente in magazzino" data-testid="overtime-note" /></div>
          <p className="text-xs text-slate-500">Il dipendente riceve la notifica e accetta o rifiuta dall'app. Le ore timbrate in questa fascia contano come straordinario.</p>
          <Button onClick={send} disabled={busy} className="h-11 w-full rounded-full" data-testid="overtime-send">{busy && <Loader2 className="h-4 w-4 animate-spin" />} Invia richiesta</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
